import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { useDispatch, useSelector } from "react-redux";
import LayoutModal from "../common/components/layouts/LayoutModal";
import ButtonContainer from "../../lib/components/Button";
import Actions from "./duck/actions";
import { useHistory, useLocation } from "react-router";
import { GroupAvatarsContainer } from "../../lib/components/GroupAvatars/GroupAvatarsContainer";

export default function AskForShortListModal() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const isOpenShortListModal = useSelector(
    (state) => state?.user?.isOpenShortListModal
  );

  const shortlistedPrograms = useSelector(
    (state) => state?.planner?.shortlistedPrograms
  );

  const [showShortlistModal, setShowShortlistModal] = useState(false);

  const onCloseModal = () => {
    dispatch(Actions.isOpenShortListModal(false));
  };

  useEffect(() => {
    setShowShortlistModal(isOpenShortListModal);
  }, [isOpenShortListModal]);

  return (
    showShortlistModal &&
    !shortlistedPrograms?.length &&
    ReactDOM.createPortal(
      <LayoutModal
        showModal={showShortlistModal}
        setShowModal={setShowShortlistModal}
        showCloseIcon={true}
        className={"min-h-full pb-20 lg:pb-0"}
        modalHeight="h-max"
        closeButtonClassnames="top-6 right-6"
        onCloseModal={onCloseModal}
      >
        <div className="flex flex-col justify-center items-center px-14 pt-14 pb-10">
          <div className="flex flex-col items-center my-6 space-y-2 text-2xl font-bold text-center lg:mt-6 lg:text-3xl">
            <span>Get FREE Abroad University Shortlist in 90 Seconds⚡</span>
          </div>
          <GroupAvatarsContainer
            imgSrcSet={[
              "https://randomuser.me/api/portraits/men/9.jpg",
              "https://randomuser.me/api/portraits/women/50.jpg",
              "https://randomuser.me/api/portraits/men/38.jpg",
              "https://randomuser.me/api/portraits/women/22.jpg",
              "https://randomuser.me/api/portraits/women/13.jpg",
            ]}
            dimensions={"w-12 h-12"}
          />
          <p className="mt-4 font-medium text-center">
            20K+ students have already activated their planner
          </p>
          <ButtonContainer
            label={"Yes, Start Shortlisting"}
            variant={"primary"}
            block
            size={"responsive-base"}
            customContainerClass="py-4 mt-10 text-base lg:text-xl shimmer-primary "
            onClick={() => {
              dispatch(Actions.isOpenShortListModal(false));
              history.push(
                `/planner?utm_campaign=in-app-popup-promo&utm_medium=referral&utm_source=${location.pathname}`
              );
            }}
          />
        </div>
      </LayoutModal>,
      document.getElementById("modal")
    )
  );
}
